import { useIdentify } from '@hungryroot/customer';
import {
  useFavoritePairing,
  usePostFavoritePairing,
  useDeleteFavoritePairing,
  trackFavorite,
} from '@hungryroot/favorites';
import {
  type IconButtonStyleVariant,
  type IconButtonSizeVariant,
  type IconButtonProminenceVariant,
} from '@hungryroot/ramen';
import { BookmarkButton } from '../BookmarkButton/BookmarkButton';

interface RecipeBookmarkButtonProps {
  pairingId: number;
  pairingName: string;
  size?: IconButtonSizeVariant;
  style?: IconButtonStyleVariant;
  prominence?: IconButtonProminenceVariant;
  onBookmark?: () => void;
}

export function RecipeBookmarkButton(props: RecipeBookmarkButtonProps) {
  const { pairingId, pairingName, size, style, prominence, onBookmark } = props;
  const customer = useIdentify();
  const customerId = customer.customerData?.id || 0;
  const { isFavorited } = useFavoritePairing({ customerId, pairingId });
  const postFavoritePairing = usePostFavoritePairing();
  const deleteFavoritePairing = useDeleteFavoritePairing();

  if (isFavorited === undefined) {
    return null;
  }

  const onClick = () => {
    if (isFavorited) {
      deleteFavoritePairing.mutate({
        customerId,
        pairingId,
      });
    } else {
      onBookmark?.();
      postFavoritePairing.mutate({
        customerId,
        body: {
          pairing_id: pairingId,
        },
      });
    }

    trackFavorite({
      id: pairingId,
      name: pairingName,
      category: 'pairings',
      location: 'RDP',
      state: !isFavorited,
    });
  };

  return (
    <BookmarkButton
      isBookmarked={isFavorited}
      onClick={onClick}
      size={size}
      style={style}
      prominence={prominence}
    />
  );
}
